import React from 'react';

const AccruedBenefitsDescription = () => (
  <va-details
    label="Accrued benefits are considered for all claims"
    class="vads-u-margin-bottom--4"
  >
    <p>
      Accrued benefits are unpaid benefits that a Veteran was already entitled
      to receive prior to death, which are now payable to the survivor of the
      Veteran.
    </p>
  </va-details>
);

export default AccruedBenefitsDescription;
